module.exports = __webpack_public_path__ + "static/media/home11.eedcdfee.jpg";